import React from 'react';
import { Briefcase, GraduationCap, Building2 } from 'lucide-react';
import SectionDirectory from '../components/SectionDirectory';
import JobsStrip from '../components/JobsStrip';

const GROUPS = [
  {
    name: 'Local vacancies',
    icon: <Briefcase size={17} />,
    blurb: 'Jobs advertised across Paisley and Renfrewshire.',
    links: [
      { name: 'Paisley Scotland jobs board', url: 'https://paisleyscotland.com/jobs', note: 'Our sister site — local vacancies, updated daily' },
      { name: 'Renfrewshire Council vacancies', url: 'https://www.renfrewshire.gov.uk/jobs', note: 'Council roles, apprenticeships and modern apprenticeships' },
      { name: 'myjobscotland', url: 'https://www.myjobscotland.gov.uk', note: 'Every Scottish council in one place' },
      { name: 'NHS Scotland recruitment', url: 'https://apply.jobs.scot.nhs.uk', note: 'Including the Royal Alexandra Hospital' },
    ],
  },
  {
    name: 'Training & skills',
    icon: <GraduationCap size={17} />,
    blurb: 'Courses, apprenticeships and back-to-work support.',
    links: [
      { name: 'West College Scotland', url: 'https://www.westcollegescotland.ac.uk', note: 'Paisley campus — full and part-time courses' },
      { name: 'University of the West of Scotland', url: 'https://www.uws.ac.uk', note: 'Paisley campus' },
      { name: 'Skills Development Scotland', url: 'https://www.skillsdevelopmentscotland.co.uk', note: 'Free careers advice at any age' },
      { name: 'Apprenticeships.scot', url: 'https://www.apprenticeships.scot', note: 'Modern, graduate and foundation apprenticeships' },
    ],
  },
  {
    name: 'Business & self-employment',
    icon: <Building2 size={17} />,
    blurb: 'Starting or growing something of your own.',
    links: [
      { name: 'Business Gateway Renfrewshire', url: 'https://www.bgateway.com', note: 'Free local business advice and workshops' },
      { name: 'Invest Renfrewshire', url: 'https://www.renfrewshire.gov.uk/business', note: 'Council support for local businesses' },
      { name: 'Advertise with us', url: '/sponsors', internal: true, note: 'Reach Paisley through paisley.org.uk' },
    ],
  },
];

const JobsPage = () => (
  <SectionDirectory
    kicker="Work in Renfrewshire"
    title="Jobs"
    intro="Local vacancies, training and business support for people in Paisley and Renfrewshire — gathered in one place."
    seo={{
      title: 'Jobs in Paisley & Renfrewshire — vacancies, training and business support',
      description: 'Local job vacancies, apprenticeships, college and university courses, and business support for Paisley and Renfrewshire.',
      url: '/jobs',
    }}
    groups={GROUPS}
    footnote="Vacancies shown above are published and managed by the organisations listed — always apply through their own site. We do not process applications."
  >
    <div className="mb-12">
      <JobsStrip />
    </div>
  </SectionDirectory>
);

export default JobsPage;
